import React from 'react';

import PassBox from "./PassBox";

export default function PassGroup(props) {
  //console.log('PassGroup>> ' + props.loginJwt)
  return (
    <>
      {
        props.data.map((item, index) => {
          return (
            <div key={`pass-group-${index}`} className="passGroup">
              <div className={`passSectionTitleWrap_type${item.type}`}>
                <em className="passSectionTitle">{item.title}</em>
                {item.sub_title && (<p className="passSectionText">{item.sub_title}</p>)}
              </div>
              {
                item.products &&
                (<div key={`pass-group-product-${index}`} className="passGroupList">
                  <PassBox data={item.products} type={item.type} group={item.group} loginJwt={props.loginJwt} platform={props.platform} displayLang={props.displayLang} />
                </div>)
              }
            </div>
          )
        })
      }
    </>
  );
}
